
export default {
  props: {
    slides: {
      type: Array,
      default: null
    }
  }
}
